export const BACKGROUND_UPLOAD_THRESHOLD = 50 * 1024 * 1024;

export function shouldUseBackgroundUploads(files) {
    const totalSize = Array.from(files || []).reduce((total, file) => total + file.size, 0);

    return totalSize >= BACKGROUND_UPLOAD_THRESHOLD;
}
